<template>

  <section class="rooms" ref="rooms">
    <h2 class="rooms__title">Le soluzioni disponibili</h2>
    <div class="rooms__wrap">
      <div class="rooms__content">

        <div class="rooms__not-found" v-if="!rooms.length">
          <img src="/assets/images/alpitour/statics/symbol_w_girl.png" alt="" />
          <p>
            Siamo spiacenti! Non ci sono soluzioni disponibili.<br>
            <strong>Prova a selezionare un'altra proposta o a cambiare i criteri di ricerca.</strong>
          </p>
        </div>

        <div v-else>
          <div class="rooms__dates">
            <vb-icon class="rooms__dates-icon" :name="'calendar'" :size=16 :color="sass('primary')" />
            <span>{{ dates_label }}</span>
          </div>
          <span class="rooms__subtitle">Camere e trattamenti</span>
          <b-row>
            <b-col
              lg="12"
              xl="6"
              class="rooms__element"
              v-for="(room, room_index) in rooms"
              :key="_uid+'room'+room_index"
            >
              <room
                :room="room"
                :room_index="room_index"
              />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Room from './room.vue'

export default {
  name: 'rooms',

  inheritAttrs: false,

  components: {
    Room,
  },

  props: {
    hotel_data: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapState({
      checkin: state => state.liveat.checkin_date,
      checkout: state => state.liveat.checkout_date,
      nights: state => state.liveat.days,
    }),

    dates_label() {
      if (!this.checkin || !this.checkout || !this.nights) return ''
      const fmt = 'D MMMM YYYY'
      const from = moment(this.checkin).locale('it').format(fmt)
      const to = moment(this.checkout).locale('it').format(fmt)
      const nights_label = this.nights === 1 ? '1 notte' : this.nights + ' notti'
      return from + ' - ' + to + ' (' + nights_label + ')'
    },

    rooms() {
      const hotel_data = (this.hotel_data && this.hotel_data.data)
      if (hotel_data && hotel_data.rooms) return hotel_data.rooms
      return []
    },
  },
}
</script>

<style lang="scss" scoped>

  .rooms {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__content {
      @extend %section__content;
      line-height: normal;
    }

    &__dates {
      font-size: $font-size-lg;
      color: $primary;
      font-weight: $vb-font-weight-semibold;
      display: flex;
      align-items: center;

      &-icon {
        margin-right: $grid-gutter-width / 6;
      }
    }

    &__subtitle {
      display: block;
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin: $grid-gutter-width 0 0;
    }

    &__element {
      margin-top: $grid-gutter-20;
    }
  }

  ::v-deep {
    .vb-card {
      &__image {
        overflow: hidden;

        &[style*="room_placeholder"] {
          &:hover {
            cursor: default;
          }
          &:after {
            display: none !important;
          }
        }

        &:after {
          content: '';
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: rgba(255,255,255, .5);
          background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgY2xhc3M9ImZlYXRoZXIgZmVhdGhlci16b29tLWluIiBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjgiLz48bGluZSB4MT0iMjEiIHgyPSIxNi42NSIgeTE9IjIxIiB5Mj0iMTYuNjUiLz48bGluZSB4MT0iMTEiIHgyPSIxMSIgeTE9IjgiIHkyPSIxNCIvPjxsaW5lIHgxPSI4IiB4Mj0iMTQiIHkxPSIxMSIgeTI9IjExIi8+PC9zdmc+');
          background-size: 60%;
          background-repeat: no-repeat;
          background-position: center center;
          width: 40px;
          height: 40px;
          border-radius: 200px;

          @include media-breakpoint-up(lg) {
            display: none;
            top: auto;
            right: 30px;
            bottom: 10px;
          }
        }

        &:hover {
          cursor: pointer;

          &:after {
            display: block;
          }
        }
      }

      &__title {
        @include media-breakpoint-up(lg) {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      &__text {
        font-size: $font-size-sm;
        max-height: $grid-gutter-width * 3;
        overflow: hidden;
      }

      &__wrap {
        border: 1px solid $gray-200;
        position: relative;
      }
    }
  }

</style>